import React from "react";
import withStyles from '@mui/styles/withStyles';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import Button from '@mui/material/Button';


const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }

});

const DeleteTransporteurCompteDialog = ({ classes, onClose, onClickDelete, transporteur, transporteurCompte }) => {
       
    const remove = () => {
        onClickDelete(transporteur.id, transporteurCompte.id);
    };

    return (
        <Dialog open>
            <DialogTitle>Suppression d'un compte transporteur</DialogTitle>

            <DialogContent className={classes.dialogContent}>

                <p>Êtes-vous sûr de vouloir supprimer le compte {transporteurCompte.compte} du transporteur : {transporteur.nom} / {transporteur.code} ({transporteur.id}) ?</p>


            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={remove}
                    variant="contained"
                    color="secondary"
                >
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(DeleteTransporteurCompteDialog);
